import Quill from 'quill';

const BlockEmbed = Quill.import('blots/block/embed');

class PostEditorCustomVideo extends BlockEmbed {
    static create(value) {
        const node = super.create();
        node.setAttribute('controls', true);
        node.setAttribute('src', value);
        node.setAttribute('style', 'max-width: 100%; border-radius: 8px; margin: 10px 0;');
        return node;
    }

    static value(node) {
        return node.getAttribute('src');
    }
}

PostEditorCustomVideo.blotName = 'PostEditorCustomVideo';
PostEditorCustomVideo.tagName = 'video';

export default PostEditorCustomVideo;